import React from 'react';

import Button from 'brandComponents/Button';

import {ISocialLoginButtonProp} from './ISocialLoginButton';

const SocialLoginButton = ({
	idp,
	classNames,
	children,
	handleSocialLoginBtn,
	isRedirectLogin,
}: ISocialLoginButtonProp) => {
	return (
		<Button
			classNames={classNames}
			type="button"
			onClick={() => handleSocialLoginBtn(idp, isRedirectLogin)}
		>
			{children}
		</Button>
	);
};

export default SocialLoginButton;
